import React from "react";

const Youtube = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 30 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_164_675)">
      <path
        d="M29.3752 3.2794C29.0295 1.98789 28.0145 0.972954 26.7229 0.627234C24.3818 0 15 0 15 0C15 0 5.61821 0 3.27955 0.627234C1.98798 0.972954 0.973 1.98789 0.627264 3.2794C0 5.61794 0 10.5 0 10.5C0 10.5 0 15.3821 0.627264 17.7206C0.973 19.0121 1.98798 20.027 3.27955 20.3728C5.61821 21 15 21 15 21C15 21 24.3818 21 26.7204 20.3728C28.012 20.027 29.027 19.0121 29.3727 17.7206C30 15.3821 30 10.5 30 10.5C30 10.5 30 5.61794 29.3727 3.2794H29.3752ZM11.9995 14.9993V6.00071L19.7934 10.5L11.9995 14.9993Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_164_675">
        <rect width="30" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Youtube.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};
export default Youtube;
